import styles from './Footer.module.scss';
import { useTranslation } from 'react-i18next';
import { VdsFooter, VdsLink } from '@volt/volt-extended-components-react';
import { ExternalUrl } from '@cas/config/links';

interface LinkData {
  url: string;
  value: string;
}

const FOOTER_LINKS: LinkData[] = [
  { value: 'PrivacyPolicy', url: ExternalUrl.PrivacyPolicy },
  { value: 'ContactUs', url: ExternalUrl.MiningContact },
];

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <VdsFooter appVersion={t('DigitalMine')} type="default">
        {FOOTER_LINKS.map(({ url, value }: LinkData) => {
          return (
            <VdsLink
              key={value}
              url={url}
              value={t(value)}
              variant="footer"
              target="_blank"
              rel="noopener noreferrer"
            />
          );
        })}
      </VdsFooter>
    </footer>
  );
}

export default Footer;
